<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>
      <a [routerLink]="['/agenda']">Templates</a>
    </li>
  </ul>
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong>Templates</strong>
      </span>
    </div>
  
    <div class="card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <label>Upload Agenda Index Template</label>
              <label class="input-group">
                <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)]="indexTemplateFileName">
  
                <span class="input-group-addon default" (click)="downloadFile(indexTemplateDocId)" *ngIf="indexTemplateDocId">
                  <i class="fa fa-download"></i>
                </span>
                <span class="input-group-addon warning" (click)="initiateUploadIndexDocs()" [appHasPermission]="{'Url': '/Templates/edit?goveva=true&email=', 'method':'put', 'menu': 'Templates'}">
                  <i class="fa fa-upload"></i>
                </span>
  
              </label>
            </div>
            <div class="col-md-4">
              <label>Upload Agenda Template</label>
              <label class="input-group">
                <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)]="templateFileName">
  
                <span class="input-group-addon default" (click)="downloadFile(templateDocId)" *ngIf="templateDocId">
                  <i class="fa fa-download"></i>
                </span>
                <span class="input-group-addon warning" (click)="initiateUploadAgendaDocs()" [appHasPermission]="{'Url': '/Templates/edit?goveva=true&email=', 'method':'put', 'menu': 'Templates'}">
                  <i class="fa fa-upload"></i>
                </span>
  
              </label>
            </div>
            <div class="col-md-4">
              <label>Upload Notice Template</label>
              <label class="input-group">
                <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)]="noticeTemplateFileName">
  
                <span class="input-group-addon default" (click)="downloadFile(noticeTemplateDocId)" *ngIf="noticeTemplateDocId">
                  <i class="fa fa-download"></i>
                </span>
                <span class="input-group-addon warning" (click)="initiateUploadNoticeDocs()" [appHasPermission]="{'Url': '/Templates/edit?goveva=true&email=', 'method':'put', 'menu': 'Templates'}">
                  <i class="fa fa-upload"></i>
                </span>
  
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12"></div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label>Upload Agenda Individual Template</label>
          <label class="input-group">
            <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)]="agendaIndividualTemplateFileName">
  
            <span class="input-group-addon default" (click)="downloadFile(agendaIndividualTemplateDocId)" *ngIf="agendaIndividualTemplateDocId">
              <i class="fa fa-download"></i>
            </span>
            <span class="input-group-addon warning" (click)="initiateUploadAgendaIndividualDocs('IndividualTemplate')" [appHasPermission]="{'Url': '/Templates/edit?goveva=true&email=', 'method':'put', 'menu': 'Templates'}">
              <i class="fa fa-upload"></i>
            </span>
  
          </label>
        </div>
        <div class="col-md-4">
          <label>Upload Minutes Individual Template</label>
          <label class="input-group">
            <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)]="minuteIndividualTemplateFileName">
  
            <span class="input-group-addon default" (click)="downloadFile(minuteIndividualTemplateDocId)" *ngIf="minuteIndividualTemplateDocId">
              <i class="fa fa-download"></i>
            </span>
            <span class="input-group-addon warning" (click)="initiateUploadAgendaIndividualDocs('IndividualMinuteTemplate')" [appHasPermission]="{'Url': '/Templates/edit?goveva=true&email=', 'method':'put', 'menu': 'Templates'}">
              <i class="fa fa-upload"></i>
            </span>
  
          </label>
        </div>
        <div class="col-md-4">
          <label>Upload Minutes Template</label>
          <label class="input-group">
            <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)]="minuteTemplateFileName">
  
            <span class="input-group-addon default" (click)="downloadFile(minuteTemplateDocId)" *ngIf="minuteTemplateDocId">
              <i class="fa fa-download"></i>
            </span>
            <span class="input-group-addon warning" (click)="initiateUploadAgendaIndividualDocs('Minutes')" [appHasPermission]="{'Url': '/Templates/edit?goveva=true&email=', 'method':'put', 'menu': 'Templates'}">
              <i class="fa fa-upload"></i>
            </span>
  
          </label>
        </div>
        <!-- <div class="col-md-4">
          <label>Upload Notice Template</label>
          <label class="input-group">
            <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)] = "noticeTemplateFileName">
  
            <span class="input-group-addon default" (click)="downloadFile(noticeTemplateDocId)" *ngIf="noticeTemplateDocId">
              <i class="fa fa-download"></i>
            </span>
            <span class="input-group-addon warning" (click)="initiateUploadNoticeDocs()">
              <i class="fa fa-upload"></i>
            </span>
  
          </label>
        </div> -->
      </div>
    </div>
  </section>
  
  <div class="modal fade modal-size-medium" id="agendaDocxUploadDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fa fa-upload"></i>
            <span id="AgendaDocumentUploadTitle"></span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
  
            <!-- <div class="row">
              <div class="col-md-4">
                <label class="form-control-label">Agenda Template
                </label>
              </div>
              <div class="col-md-8">
                <label class="input-group">
                  <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)]="templateFileName" accept=".docx">
                  <span class="input-group-addon default" *ngIf="templateFileName" (click)="downloadFile('style')">
                    <i class="fa fa-download"></i>
                  </span>
                  <span class="input-group-addon warning" (click)="uploadTemplate()">
                    <i class="fa fa-upload"></i>
                  </span>
                </label>
              </div>
  
            </div> -->
  
            <div class="row">
  
              <div class="col-md-4">
                <label class="col-form-label" for="l5">
                  <span>Upload Template
                    <span _ngcontent-c2="" style="color: red;">*</span>
                  </span>
                </label>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <input type="file" class='form-control fileUpload' (change)="agendaDocsChangeEvent($event)" accept=".docx" />
                  <span style="color: red" *ngIf="!extensionCheck">
                    Only DOCX Type File is allowed to upload.
                  </span>
  
                </div>
                <!-- {{fileHasError | json}} -->
  
              </div>
  
            </div>
            <!-- <div class="row">
              <div class="col-md-4">
                <label class="form-control-label">Index Template
                </label>
              </div>
              <div class="col-md-8">
                <label class="input-group">
                  <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)]="indexTemplateFileName">
                  <span class="input-group-addon default" *ngIf="indexTemplateFileName" (click)="downloadFile('index')">
                    <i class="fa fa-download"></i>
                  </span>
                  <span class="input-group-addon warning" (click)="uploadIndexTemplate()">
                    <i class="fa fa-upload"></i>
                  </span>
                </label>
              </div>
  
            </div> -->
            <!-- <div class="row" *ngIf="uploadIndexDoc">
  
              <div class="col-md-4">
                <label class="col-form-label" for="l5">
                  <span>Upload Template
                    <span _ngcontent-c2="" style="color: red;">*</span>
                  </span>
                </label>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <input type="file" class='form-control fileUpload' (change)="indexDocsChangeEvent($event)" accept=".docx" />
                  <span style="color: red">
                    Only DOCX Type File is allowed to upload.
                  </span>
  
                </div>
  
              </div>
  
            </div> -->
  
          </div>
        </div>
        <div class="modal-footer">
  
          <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary" (click)="uploadAgendaDocFile()" [disabled]="!extensionCheck">
            <i class="fa fa-save"></i>&nbsp;Upload</button>
  
          <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;Close</button>
  
        </div>
      </div>
    </div>
  </div>
  
  <div class="modal fade modal-size-medium" id="indexTemplateUploadDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fa fa-upload"></i>
            <span id="AgendaIndexUploadTitle"></span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
  
            <!-- <div class="row">
              <div class="col-md-4">
                <label class="form-control-label">Index Template
                </label>
              </div>
              <div class="col-md-8">
                <label class="input-group">
                  <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)]="indexTemplateFileName">
                  <span class="input-group-addon default" *ngIf="indexTemplateFileName" (click)="downloadFile('index')">
                    <i class="fa fa-download"></i>
                  </span>
                  <span class="input-group-addon warning" (click)="uploadIndexTemplate()">
                    <i class="fa fa-upload"></i>
                  </span>
                </label>
              </div>
  
            </div> -->
            <div class="row">
  
              <div class="col-md-4">
                <label class="col-form-label" for="l5">
                  <span>Upload Template
                    <span _ngcontent-c2="" style="color: red;">*</span>
                  </span>
                </label>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <input type="file" class='form-control fileUpload' (change)="indexDocsChangeEvent($event)" accept=".docx" />
                  <span style="color: red" *ngIf="!changefileExtension">
                    Only DOCX Type File is allowed to upload.
                  </span>
  
                </div>
  
              </div>
  
            </div>
  
          </div>
        </div>
        <div class="modal-footer">
  
          <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary" (click)="uploadIndexTemplateFile()" [disabled]="!changefileExtension">
            <i class="fa fa-save"></i>&nbsp;Upload</button>
  
          <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;Close</button>
  
        </div>
      </div>
    </div>
  </div>
  
  <div class="modal fade modal-size-medium" id="noticeTemplateUploadDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fa fa-upload"></i>
            <span id="noticeUploadTitle"></span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
  
            <!-- <div class="row">
              <div class="col-md-4">
                <label class="form-control-label">Index Template
                </label>
              </div>
              <div class="col-md-8">
                <label class="input-group">
                  <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)]="indexTemplateFileName">
                  <span class="input-group-addon default" *ngIf="indexTemplateFileName" (click)="downloadFile('index')">
                    <i class="fa fa-download"></i>
                  </span>
                  <span class="input-group-addon warning" (click)="uploadIndexTemplate()">
                    <i class="fa fa-upload"></i>
                  </span>
                </label>
              </div>
  
            </div> -->
            <div class="row">
  
              <div class="col-md-4">
                <label class="col-form-label" for="l5">
                  <span>Upload Template
                    <span _ngcontent-c2="" style="color: red;">*</span>
                  </span>
                </label>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <input type="file" class='form-control fileUpload' (change)="noticeDocsChangeEvent($event)" accept=".docx" />
                  <span style="color: red" *ngIf="!isExtensionTrue">
                    Only DOCX Type File is allowed to upload.
                  </span>
  
                </div>
  
              </div>
  
            </div>
  
          </div>
        </div>
        <div class="modal-footer">
  
          <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary" (click)="uploadNoticeTemplateFile()" [disabled]="!isExtensionTrue">
            <i class="fa fa-save"></i>&nbsp;Upload</button>
  
          <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;Close</button>
  
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade modal-size-medium" id="agendaIndividualDocxUploadDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fa fa-upload"></i>
            <span id="AgendaIndividualDocumentUploadTitle"></span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
  
            <div class="row">
  
              <div class="col-md-4">
                <label class="col-form-label" for="l5">
                  <span>Upload Template
                    <span _ngcontent-c2="" style="color: red;">*</span>
                  </span>
                </label>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <input type="file" class='form-control fileUpload' (change)="IndividualDocsChangeEvent($event)" />
                  <span style="color: red" *ngIf="!indFileExtension">
                    Only DOCX Type File is allowed to upload.
                  </span>
  
                </div>
  
              </div>
  
            </div>
          </div>
        </div>
        <div class="modal-footer">
  
          <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary" (click)="uploadIndividualAgendaDocFile()" *ngIf="btnFor == 'IndividualTemplate'"
            [disabled]="!indFileExtension">
            <i class="fa fa-save"></i>&nbsp;Upload</button>
  
          <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary" (click)="uploadMinuteDocFile()" *ngIf="btnFor == 'Minutes'"
            [disabled]="!indFileExtension">
            <i class="fa fa-save"></i>&nbsp;Upload</button>
  
          <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary" (click)="uploadIndividualMinuteDocFile()" *ngIf="btnFor == 'IndividualMinuteTemplate'"
            [disabled]="!indFileExtension">
            <i class="fa fa-save"></i>&nbsp;Upload</button>
  
          <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;Close</button>
  
        </div>
      </div>
    </div>
  </div>
  <app-alert></app-alert>